import { Result } from "antd";
import React from "react";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { appInsights, getBrowserAndOsInfo } from "../appInsights";
import store from "../reducers/store";
class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		if (
			process.env.REACT_APP_INSTRUMENTATION_KEY !== undefined &&
			process.env.REACT_APP_INSTRUMENTATION_KEY &&
			process.env.REACT_APP_INSTRUMENTATION_KEY !== ""
		) {
			appInsights.trackException({
				error: error,
				exception: error,
				severityLevel: SeverityLevel.Error,
				properties: { errorInfo },
			});
			appInsights.trackTrace({
				message: errorInfo.componentStack,
				properties: {
					reduxState: store.getState(),
					browserOs: getBrowserAndOsInfo(),
				},
			});
		}
		console.log(error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<Result
					status="error"
					title="Application Error"
					subTitle="An error has occurred, and we couldn't recover from it. Apologies for the inconvenience. Please contact the administrator and describe what action caused this bug to happen."
				></Result>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
